<app-add-edit-roles [data]="data" [grouping]="grouping" (submitRole)="submit($event)"></app-add-edit-roles>
